import StatusView from "../StatusView.vue";
import StatusList from "../Pages/StatusList.vue";
import StatusDetailList from "../Pages/StatusDetailList.vue";
import PaymentCodeStatusDetailList from "../Pages/PaymentCodeStatusDetailList.vue";
import PaymentMarkAsPaid from '../Pages/PaymentMarkAsPaid.vue';
import PaymentMadeList from '../Pages/PaymentMadeList.vue';
import PaymentMadeUpload from '../Pages/PaymentMadeUpload.vue';

const routes = [
  {
    path: 'status',
    component: StatusView,
    children: [
      {
        path: '',
        name: 'celulares-status',
        roles: ['status_pago_lista'],
        component: StatusList
      },
      {
        path: 'abonos',
        name: 'celulares-status-made-batch-list',
        roles: ['status_pago_carga_abonos'],
        component: PaymentMadeList
      },
      {
        path: 'abonos/carga',
        name: 'celulares-status-made-batch-upload',
        roles: ['status_pago_carga_abonos_carga'],
        component: PaymentMadeUpload
      },
      {
        path: ':periodId/detalle',
        name: 'celulares-status-details',
        roles: ['status_pago_lista_periodo'],
        component: StatusDetailList,
      },
      {
        path: ':periodId/detalle/:paymentCode',
        name: 'celulares-status-details-payment-code',
        roles: ['status_pago_lista_codigo'],
        component: PaymentCodeStatusDetailList,
      },
      {
        path: ':periodId/detalle/:paymentCode/:resultId/:id/marcar-como-pagado',
        name: 'celulares-status-payment-mark-as-paid',
        roles: ['status_pago_lista_codigo_pagar'],
        component: PaymentMarkAsPaid
      }
    ]
  },
]

export default routes
